export default "__VITE_ASSET__CCUMTN50__"